import { render } from "./BgyxMenuTop.vue?vue&type=template&id=07517eee"
import script from "./BgyxMenuTop.vue?vue&type=script&lang=js"
export * from "./BgyxMenuTop.vue?vue&type=script&lang=js"

import "./BgyxMenuTop.vue?vue&type=style&index=0&id=07517eee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__